import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBoldDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.4 24.36 24 34.92l9.6-10.56h-3.84v-9.6H18.24v9.6z" })
});
export default SvgArrowBoldDown;
